
/**
 * Helper
 */
var helper = require('../../helper');

/**
 * Other necessary controllers
 */
var ToastrController = new (require('../../services/ToastrController'));

function InspectionController($modal, $inspectionCalendarOfPropertyController) {

    // This is how:
    this.$modal = $modal;
    this.$submitButton = $modal.find('.modal-submit-button');
    this.ModalFormController = new (require('../../services/modals/ModalFormController'))($modal);
//    this.InspectionCalendarOfPropertyController = new (require('./InspectionCalendarOfPropertyController'))();
    this.InspectionCalendarOfPropertyController = $inspectionCalendarOfPropertyController;
    this.datatableId = $modal.data('datatable');

    var self = this; // Needed for using all constructor variables inside this function, note the difference -> no "this" but "var" at the beginning

    (function()
    {

        // Someone filled all fields and
        self.$submitButton.click(function(e){

            e.preventDefault();

            $.ajax(
                {
                type: 'POST',
                url: helper.getOrigin() + "/inspections",
                data: self.ModalFormController.getFieldsData(),
                dataType: 'json',

                success: function(data) {
                    self.clearModal();
                    self.closeModal();
                    if (data.status == 'error') {
                        ToastrController.showDanger(data.message);
                    } else {
                        ToastrController.showSuccess(data.message);
                        self.InspectionCalendarOfPropertyController.render();
                    }

                },

                error: function(data) {

                    var errors = data.responseJSON;

                    // Now display all errors from validation
                    self.ModalFormController.displayErrors(errors);

                }
            });
        });

    }());

}

InspectionController.prototype.clearModal = function() {
    this.ModalFormController.clearModal();
}

InspectionController.prototype.showModal = function() {
    this.ModalFormController.showModal();
}

InspectionController.prototype.closeModal = function() {
    this.ModalFormController.closeModal();
}

module.exports = InspectionController;